import { SerializableObject } from '@pwp-common';

import { UploadDictionary } from '../../interfaces';

export const serializeUploadDictionary = (data: UploadDictionary): UploadDictionary => {
  const serializedData: UploadDictionary = {};
  for (const [key, value] of Object.entries(data)) {
    serializedData[key] = value instanceof SerializableObject ? (value as any).serialize() : value;
  }
  return serializedData;
};
